import { Image } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
// import Img from '../../assets/images/info.svg';
// import ImgHover from '../../assets/images/info_hover.svg';
import { HoverImageProps } from '../../interfaces/components';

const HoverImage = ({ w, h, src, hover, onClick }: HoverImageProps) => {
  const [toDisplay, setToDisplay] = useState<string>();

  useEffect(() => {
    setToDisplay(src);
  }, [src]);

  return (
    <>
      <Image
        src={toDisplay}
        onMouseEnter={() => setToDisplay(hover)}
        onMouseOut={() => setToDisplay(src)}
        w={w}
        h={h}
        objectFit="contain"
        alt="hover"
        cursor="pointer"
        onClick={onClick}
        userSelect="none"
      />
    </>
  );
};

export default HoverImage;
